export enum Permissions {
  READ ="READ",
  SETTING_ALERTS_EVENTS_SAVE = "SETTING_ALERTS_EVENTS_SAVE",
  SETTING_DND_SAVE = "SETTING_DND_SAVE",
  SETTING_THRESHOLD_SAVE = "SETTING_THRESHOLD_SAVE",
}

export enum Roles {
  ROLE_USER= "USER",
  ROLE_ADMIN = "ADMIN"
}

export enum ShipmentAccessType {
  ACM = 'ACM',
  LEGACY = 'LEGACY',
}

export enum FeatureAccessType {
  ADMIN = 'ADMIN',
  NORMAL = 'NORMAL',
}

export enum AccessSource {
  TOKEN = 'TOKEN',
  FIRST_USER = 'FIRST_USER',
  ADMIN_OVERRIDE = 'ADMIN_OVERRIDE',
}